import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles((theme: Theme) => ({
    tooltip: {
        color: theme.palette.background.paper,
        backgroundColor: theme.palette.secondary.main,
    },
    arrow: {
        color: theme.palette.secondary.main,
    },
}))
